import { APIDownError, CartUrl } from "../directives/utilities/urls";

/*****************************************************************************************************************************************************
 * Revision History
 * 2025-04-27 TBH - Added PageSize property.
 *****************************************************************************************************************************************************/

export default function coursesList() {
// console.log( 'coursesList()' );
  return {
    selectedSubjectFilter: document.getElementById("categoryId")?.value || [],
    subjectList: [],
    seasonList: [],
    DeliveryOptionsList: [],
    showErrorMesage: "",
    selectedDeliveryOptions: [],
    selectedApprovedOptions: [],
    selectedCreditCEUOptions: "",
    selectedQuarter: "",            // Set by Init() via bindDropDownListData(). Updated ?. Must be in YYYYTERM format
    lateFeeMessage:'You will be assessed a $25 late fee if you are enrolling one day after the course start date. You should work with the instructor to catch up on coursework.<br/><br/>Click OK if you still wish to enroll. Otherwise, click Cancel.',
    addedCoursesList: [],
    selectedCourse:'',              
    coursesList: [],
    tempCoursesList: [],
    totalCount: 0,
    pageSize: -1,
    pageCount: 0,
    currentPage: 1,
    hasMore: false,
    showLoader: false,
    txtTopSearchFilter: "",
    courseDeailsUrl: "",
    isKeywordSearchCalll: false,
    passedAcademicTerm: "",
    passedAcademicYear: "",
    selectedCourseLength: "",
    selectedDeliveryValue: "",
    categoryId: "",
    nonTradCode: document.getElementById("nonTradCode") != null
        ? document.getElementById("nonTradCode").value
        : "",
    txtTopSearchFilterMobile: '',
    passedKeyword: '',
    checkOutMessage:'',
    isRestrictedAccount:false,
    paginate( pageNumber ) {
      this.currentPage = pageNumber;
      this.isKeywordSearchCalll ? this.search() : this.onFilterChange();
    },
    prev() {
      this.currentPage = this.currentPage - 1;
      this.isKeywordSearchCalll ? this.search() : this.onFilterChange();
    },
    next() {
      this.currentPage = this.currentPage + 1;
      this.isKeywordSearchCalll
          ? this.search()
          : this.onFilterChange(false, this.currentPage,true);
    },
    OnQuarterChangeCall( clickedQuarter ) {
      this.selectedQuarter = clickedQuarter.academicYear + clickedQuarter.academicTerm;
      this.passedAcademicTerm = clickedQuarter.academicTerm;
      this.passedAcademicYear = clickedQuarter.academicYear;
      this.txtTopSearchFilter = "";
      this.txtTopSearchFilterMobile = "";
      this.onFilterChange();
    },
    OnDeliveryChangeCall(value) {
      this.selectedDeliveryValue = value;
      this.txtTopSearchFilter = "";
      this.txtTopSearchFilterMobile = "";
      this.onFilterChange();
    },
    OnCourseLengthChangeCall(value) {
      this.selectedCourseLength = value;
      this.txtTopSearchFilter = "";
      this.txtTopSearchFilterMobile = "";
      this.onFilterChange();
    },
    OnCreditCEUChangeCall(value) {
      this.selectedCreditCEUOptions = value;
      this.txtTopSearchFilter = "";
      this.txtTopSearchFilterMobile = "";
      this.onFilterChange();
    },
    OnCategoryChangeCall() {
      this.txtTopSearchFilter = "";
      this.txtTopSearchFilterMobile = "";
      this.onFilterChange();
    },
    getSelectedQuarter() {
      return( this.selectedQuarter );
    },
    getDetailsUrl( item ) {
      if( this.nonTradCode != null && this.nonTradCode != "" ) {
        return( this.courseDeailsUrl + "?eventId=" + encodeURIComponent(item.eventId) + "&nonTradCode=" + encodeURIComponent(this.nonTradCode));
      } else {
        return( this.courseDeailsUrl + "?eventId=" + encodeURIComponent( item.eventId ))
      }
    },
    formatEventId(eventId) {
      if (eventId != null) {
        return eventId.replace("_", " ");
      }
    },
    formatDate(dateValue) {
      const options = { month: "short", day: "numeric" };
      const formattedDate = new Date( dateValue ).toLocaleDateString( undefined, options );
      return formattedDate;
    },
    getEnrollmentStatus(item) {
      switch( item.enrollmentStatus ) {
        case 0:                   // Unknown
          return "Unknown";
          break;
        case 1:                   // Enroll
        case 3:                   // Started
        case 4:                   // StartedEnding
          return "Open";
          break;
        case 2:                   // Waitlist
          return "Course Full";
          break;
        case 5:                   // Ended
        case 6:                   // GetInfo
          return "Closed";
          break;
      }
    },
    getClassNameByEnrollmentStatus(enrollmentStatus) {
      return(( enrollmentStatus == 1  || enrollmentStatus == 4 )
          ? "block text-lg text-success lg:font-slab font-medium" 
          : "block text-lg text-alert lg:font-slab font-medium" );
    },
    bindDropDownListData() {
      fetch( "/api/ProgramAPI/GetSeasonList?top=" + 2, { 
        method: "GET" 
      }).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).then((response) => {
        if( response != undefined && response.isSuccess ) {
          Array.prototype.push.apply(this.seasonList, response.seasons);
          this.selectedQuarter = response.seasons[0].academicYear + response.seasons[0].academicTerm;
        } else {
          this.showErrorMesage = APIDownError;
        }
        this.onFilterChange(false);
      });

      var getCategoryListUrl = "/api/ProgramAPI/GetCategroyList?parentCode=";
      getCategoryListUrl += document.getElementById("categoryId") != null ? document.getElementById("categoryId").value : "";
      fetch( getCategoryListUrl, { 
        method: "GET" 
      }).then((response) => {
        if( response.ok ) {
          return response.json();
          }
      }).then((response) => {
        if (response != undefined && response.isSuccess) {
          Array.prototype.push.apply(this.subjectList, response.categories);                        
        } else {
          this.showErrorMesage = APIDownError;
        }
      });
    },

    search( mode ) { 
    // 2024-07-19 TBH - Fixed bug parsing selectedQuarter.
      var academicYear;
      var academicTerm;
      if( this.selectedQuarter.length > 0 ) {
        academicYear = this.selectedQuarter.substring(0,4); 
        academicTerm = this.selectedQuarter.substring(4);
      } else {
        academicYear = this.seasonList[0].academicYear;
        academicTerm = this.seasonList[0].academicTerm;
      }

      this.passedKeyword = mode == "desktopMode" ? this.txtTopSearchFilter : this.txtTopSearchFilterMobile;
      this.searchByKeyword = true;
      var jsonData = JSON.stringify({
        AcademicYear: academicYear,
        AcademicTerm: academicTerm,
        PageSize: this.pageSize,
        PageNumber: this.currentPage,
        Keyword: this.passedKeyword,
      });

      this.bindCoursesList( true, jsonData );
    },

    onFilterChange( isSearchCall = false, loadMore = false ) {
        this.searchByKeyword = false;
        if (!loadMore) {
            this.coursesList = [];
            this.currentPage = 1;
        }
       
        var jsonData = JSON.stringify({
            AcademicYear: this.passedAcademicYear
                ? this.passedAcademicYear
                : this.seasonList[0].academicYear,
            AcademicTerm: this.passedAcademicTerm
                ? this.passedAcademicTerm
                : this.seasonList[0].academicTerm,
            DeliveryMode: this.selectedDeliveryValue
                ? this.selectedDeliveryValue
                : "",
            CategoryID:
                this.selectedSubjectFilter.length > 0
                    ? this.selectedSubjectFilter
                    : "",
            CourseLength: this.selectedCourseLength
                ? parseInt(this.selectedCourseLength)
                : 50,
            CreditType: this.selectedCreditCEUOptions
                ? parseInt(this.selectedCreditCEUOptions)
                : 0,
            PageSize: this.pageSize,
            PageNumber: this.currentPage,
            Keyword: "",
        });
        this.bindCoursesList( isSearchCall, jsonData );
    },
    bindClassSchedule() {
    // TODO: Verify unused.
        fetch('/api/StudentAPI/GetScheduleCourses', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                AcademicYear: new Date().getFullYear(),
                AcademicTerm: "WINTER",
                PeopleCodeId: "",
                RequestType: 1,

            })
        }).then(response => {
            return response.json();
        }).then(response => {
            this.addedCoursesList = response.courses;
        });
      },

    addCartList(item) {
        if (this.addedCoursesList.length > 0) {
            for (var i = 0; i < this.addedCoursesList.length; i++) {
                if (this.addedCoursesList[i].academicTerm == item.academicTerm && this.addedCoursesList[i].serialId == item.serialId
                    && this.addedCoursesList[i].academicYear == item.academicYear
                ) {
                    alert('You have already enrolled for this course.')
                    return false;
                }
            }               
        }

        if (item.requiresLateFee) {
            this.selectedCourse = item;
            document.getElementById('btnLateFee').click();
            return false;
        }
           
          

        this.addCartItem(item);
    },
    acceptLateFeeItem() {
        if (this.selectedCourse != '' && this.selectedCourse.academicYear != undefined)
            this.addCartItem(this.selectedCourse);
    },
    addCartItem(item) {                    
        var jsonData = JSON.stringify({
            "UserSessionId": "",
            "AcademicYear": item.academicYear,
            "AcademicTerm": item.academicTerm,
            "AcademicSession": item.academicSessionId,
            "SerialId": item.serialId,
            "CheckoutType": "Course"
        });
        this.showLoader = true;

        fetch("/api/Checkout/add-course-to-cart", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: jsonData,
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                this.showLoader = false;
                if (response != undefined && response.isSuccess) {
                    window.location.href = CartUrl;
                } else if (!response.isSuccess && response.checkoutTypeError) {
                    this.checkOutMessage = response.message
                    document.getElementById('btnCartCheckOutError').click();
                }
                else if (!response.isSuccess && response.message == "Not Logged In") {
                    window.location.href = CartUrl
                }

            });
    },

    bindCoursesList( isSearchCall = false, jsonData ) {
// console.log( 'bindCoursesList()' );
// console.log( 'isSearchCall: ' + isSearchCall );
// console.log( 'jsonData: ' + jsonData );

      this.hasMore = false;
      this.showLoader = true;

      fetch("/api/ProgramAPI/GetCourseSearch", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: jsonData
      }).then(( response ) => {
        return response.json();
      }).then(( response ) => {
// console.log( 'response: ' + JSON.stringify( response ));
        this.showLoader = false;
        if (response != undefined && response.isSuccess) {
          if( isSearchCall ) {
            this.coursesList = response.courses;
          } else {
            Array.prototype.push.apply(this.coursesList, response.courses);
          }
          this.hasMore = response.hasMore;
          this.isRestrictedAccount = response.isRestrictedAccount;
          this.showErrorMesage = response.message;
        } else {
          this.showErrorMesage = response.message;
        }
      });
    },

    generateSessionId() {
      fetch('/api/UserAPI/GenerateSessionId', { 
        "method": "GET" 
      }).then(response => {
            return response.json();
      }).then( login => { })
    },
       
    init() {
// console.log( 'init()' );
        this.selectedCourseLength = 50;
        this.bindDropDownListData();
        // this.bindClassSchedule();
        this.courseDeailsUrl = document.getElementById("courseDeailsUrl").value;
// console.log( 'courseDeailsUrl [sic]: ' + this.courseDeailsUrl );            
        this.nonTradCode = document.getElementById("nonTradCode") != null
            ? document.getElementById("nonTradCode").value
            : "";
// console.log( 'nonTradCode: ' + this.nonTradCode );
        this.pageSize = parseInt( document.getElementById( "pageSize" ).value, 10 );
// console.log( 'pageSize: ' + this.pageSize );

    },
  };
}
